import { Link } from "react-router-dom";
import { categories, getVideosByCategory } from "@/mocks/videos";

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            分类快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按内容类型浏览，快速进入你想看的方向
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.map((c, index) => {
          const count = getVideosByCategory(c.key).length;
          return (
            <Link
              key={c.key}
              to={`/category/${c.key}`}
              style={{ animationDelay: `${index * 70}ms` }}
              className="group relative block rounded-lg p-6 md:p-7 bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors animate-fade-up cursor-pointer overflow-hidden"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${c.icon} text-2xl md:text-3xl`} />
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">
                {c.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {c.description}
              </p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs font-label px-2.5 py-1 rounded-full bg-accent-100 text-accent-900">
                  共 {count} 部作品
                </span>
                <span className="flex items-center gap-1 text-sm text-primary-600 font-medium">
                  进入分类
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}